export default "__VITE_ASSET__B9GMnC$x__"